import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule } from '@angular/core';

/**
 * Created by vadimdez on 28/01/2018.
 */
class ImgFallbackDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.loaded = new EventEmitter();
        this.isApplied = false;
        this.ERROR_EVENT_TYPE = 'error';
        this.LOAD_EVENT_TYPE = 'load';
        this.nativeElement = el.nativeElement;
        this.onError = this.onError.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.addEvents();
    }
    ngOnDestroy() {
        this.removeErrorEvent();
        this.removeOnLoadEvent();
    }
    onError() {
        if (this.nativeElement.getAttribute('src') !== this.imgSrc) {
            this.isApplied = true;
            this.renderer.setAttribute(this.nativeElement, 'src', this.imgSrc);
        }
        else {
            this.removeOnLoadEvent();
        }
    }
    onLoad() {
        this.loaded.emit(this.isApplied);
    }
    removeErrorEvent() {
        if (this.cancelOnError) {
            this.cancelOnError();
        }
    }
    removeOnLoadEvent() {
        if (this.cancelOnLoad) {
            this.cancelOnLoad();
        }
    }
    addEvents() {
        this.cancelOnError = this.renderer.listen(this.nativeElement, this.ERROR_EVENT_TYPE, this.onError);
        this.cancelOnLoad = this.renderer.listen(this.nativeElement, this.LOAD_EVENT_TYPE, this.onLoad);
    }
}
ImgFallbackDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ImgFallbackDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
ImgFallbackDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.10", type: ImgFallbackDirective, selector: "[src-fallback]", inputs: { imgSrc: ["src-fallback", "imgSrc"] }, outputs: { loaded: "loaded" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ImgFallbackDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[src-fallback]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { imgSrc: [{
                type: Input,
                args: ['src-fallback']
            }], loaded: [{
                type: Output,
                args: ['loaded']
            }] } });

/**
 * Created by vadimdez on 27/11/2016.
 */
class ImgFallbackModule {
}
ImgFallbackModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ImgFallbackModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ImgFallbackModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ImgFallbackModule, declarations: [ImgFallbackDirective], exports: [ImgFallbackDirective] });
ImgFallbackModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ImgFallbackModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ImgFallbackModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ImgFallbackDirective],
                    exports: [ImgFallbackDirective]
                }]
        }] });

/**
 * Created by Vadym Yatsyuk on 28.01.18
 */

/**
 * Created by Vadym Yatsyuk on 28.01.18
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ImgFallbackDirective, ImgFallbackModule };
